export default function () {
  return {
    collection: 'data_init',
    data: [
      {
        done: true
      }
    ]
  }
}
